"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuizQuestion = void 0;
const lodash_1 = __importDefault(require("lodash"));
const assignment_1 = require("../../assignment");
var QuizQuestion;
(function (QuizQuestion) {
    QuizQuestion.type = 'quiz';
    // eslint-disable-next-line @typescript-eslint/no-unsafe-declaration-merging
    class Content {
        static hasAnswer(content, number) {
            return !lodash_1.default.isEmpty(Content.answerByNumber(content, number));
        }
        static hasCorrectAnswerLessonPin(content) {
            if (Array.isArray(content.correctAnswer))
                return !lodash_1.default.isEmpty(content.correctAnswer);
            return content.correctAnswer > 0;
        }
        static getAnswerLetterByIndex(index) {
            const numToChar = ['A', 'B', 'C', 'D'];
            return numToChar[index];
        }
        // static getAnswerLetterByNumber(number: QuizQuestion.AnswerValue): string {
        //   const numToChar = ['A', 'B', 'C', 'D'];
        //   return numToChar[number - 1];
        // }
        static getAnswerNumber(letter) {
            const charToNum = {
                A: 1,
                B: 2,
                C: 3,
                D: 4,
            };
            return charToNum[letter];
        }
        static answerByNumber(content, number) {
            const prop = `answer${number}`;
            const answerText = lodash_1.default.get(content, prop);
            const answerFormula = lodash_1.default.get(content, `answerData.${prop}.html`);
            return answerText || answerFormula;
        }
    }
    QuizQuestion.Content = Content;
})(QuizQuestion || (exports.QuizQuestion = QuizQuestion = {}));
// Answer
(function (QuizQuestion) {
    let Answer;
    (function (Answer) {
        function isDone(answer) {
            return answer ? !lodash_1.default.isNil(latestAnswer(answer)) : false;
        }
        Answer.isDone = isDone;
        function answerIsCorrect(answerValue, correctAnswer) {
            return lodash_1.default.some(correctAnswer, (value) => value == answerValue);
        }
        Answer.answerIsCorrect = answerIsCorrect;
        // export function isAnswerValue(value: string): value is AnswerValue {
        //   if (typeof value !== 'number') return false;
        //   return [1, 2, 3, 4].includes(value);
        // }
        // export function validateAnswer(value: number): asserts value is AnswerValue {
        //   if (!isAnswerValue(value)) throw new AppError('invalid-params', 'is not an answer');
        // }
        function areAnswerValues(answers) {
            return Array.isArray(answers) && answers.every((a) => typeof a === 'string');
        }
        Answer.areAnswerValues = areAnswerValues;
        function correctAfterTries(answer, correctAnswer) {
            const values = (answer && answer.values) || [];
            const index = values.findIndex((v) => answerIsCorrect(v, correctAnswer));
            return index > -1 ? index + 1 : undefined;
        }
        Answer.correctAfterTries = correctAfterTries;
        function previousAnswer(answer) {
            const values = (answer && answer.values) || [];
            return values[values.length - 2];
        }
        Answer.previousAnswer = previousAnswer;
        function latestAnswer(answer) {
            const values = (answer && answer.values) || [];
            return values[values.length - 1];
        }
        Answer.latestAnswer = latestAnswer;
        function firstAnswer(answer) {
            const values = (answer && answer.values) || [];
            return values[0];
        }
        Answer.firstAnswer = firstAnswer;
        function testPointsForResult(maxPoints, result) {
            if (result && result.type === 'correct')
                return maxPoints;
            return 0;
        }
        Answer.testPointsForResult = testPointsForResult;
        function rankingPointsForResult(result) {
            if (result && result.type === 'correct')
                return 1;
            return 0;
        }
        Answer.rankingPointsForResult = rankingPointsForResult;
        function resultForAnswer(current, correctAnswer, assignmentMode) {
            const usedAnswer = latestAnswer(current);
            if (!usedAnswer) {
                return { type: 'noAnswer', correctAnswer: correctAnswer === 'hasNoCorrectAnswer' ? [] : correctAnswer };
            }
            if (correctAnswer === 'hasNoCorrectAnswer') {
                const opinionAnswer = latestAnswer(current); // cant be empty
                return { type: 'opinion', usedAnswer: opinionAnswer, correctAnswer: [] };
            }
            const isCorrect = answerIsCorrect(usedAnswer, correctAnswer);
            return { type: isCorrect ? 'correct' : 'incorrect', usedAnswer, correctAnswer };
        }
        Answer.resultForAnswer = resultForAnswer;
        function convertAssignmentPinAnswersToLessonPinAnswers(pinId, content, assignmentMeta) {
            const returnObj = {};
            content.answers.forEach((answer, index) => {
                switch (answer.type) {
                    case 'empty':
                        return;
                    case 'text':
                        returnObj[`answer${index + 1}`] = answer.text;
                        break;
                    default:
                        returnObj.answerData[`answer${index + 1}`] = answer;
                }
            });
            if (content.hasAnswer) {
                returnObj.correctAnswer = assignment_1.AssignmentMeta.correctAnswerForPin(assignmentMeta, pinId);
            }
            return returnObj;
        }
        Answer.convertAssignmentPinAnswersToLessonPinAnswers = convertAssignmentPinAnswersToLessonPinAnswers;
        function parseAnswerNumberToLetter(answer) {
            const latest = latestAnswer(answer) || undefined;
            return latest && lodash_1.default.isNumber(latest) && ['A', 'B', 'C', 'D'][latest - 1];
        }
        Answer.parseAnswerNumberToLetter = parseAnswerNumberToLetter;
    })(Answer = QuizQuestion.Answer || (QuizQuestion.Answer = {}));
})(QuizQuestion || (exports.QuizQuestion = QuizQuestion = {}));
//# sourceMappingURL=QuizQuestion.js.map